<template>
  <div class="md:pb-20 lg:pb-20 relative z-index1">
    <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto px-4"
    />
    <!-- <div
      class="absolute insights-bg z-index--1 md:block lg:block md-hidden hidden"
    >
      <img
        src="../../../../assets/images/line/insig-line.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div> -->
    <div
      class="absolute insights-bg-mob md:hidden lg:hidden block md-hidden z-index--1"
    >
      <img
        src="../../../../assets/images/line/inst-news-bg-mob.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div>
    <div class="lg:pt-0 md:pt-0">
      <div class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-4 mx-auto">
        <div
          class="lg:flex md:flex justify-between items-center lg:mt-0 md:mt-0"
        >
          <p
            class="title fsize36-16px-isg md-fsize20 lg:font-normal md:font-normal font-bold z-10"
          >
            Latest Podcast
          </p>
          <div class="lg:mt-0 md:mt-0 mt-4 lg:w-1/2 md:w-1/2">
            <div class="flex text-black">
              <b-form-select
                v-model="selectedTopic"
                class="mr-4 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null"
                  >{{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                ></b-form-select
              >
              <b-form-select
                v-model="selectedCategories"
                class="mr-4 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null" disabled
                  >{{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                ></b-form-select
              >
              <b-form-select
                v-model="selectedFilter"
                class="mr-4 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
              >
                <b-form-select-option
                  v-for="(t, index) in selectedFilterOptions"
                  :value="t"
                  :key="index"
                  >{{ t }}</b-form-select-option
                ></b-form-select
              >
              <multiselect
                class="lricon w-full text-primary cust-multitag"
                v-model="selectedUsers"
                :options="filter3"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="From Whom"
                track-by="name"
                label="name"
                :preselect-first="false"
              >
              </multiselect>
              <!-- <b-form-select
                v-model="selectedUsers"
                class="border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null" disabled
                  >{{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                ></b-form-select
              > -->
            </div>
          </div>
        </div>
        <p
          class="text-end text-primary cursor-pointer fsize14 font-semibold hov-underline sm-fsize12"
          @click="handleClear"
        >
          Clear Filter
        </p>
        <div id="topSection">
          <p
            class="joinus-subtitle md-fsize18 md:pt-10 lg:pt-10 pt-6 fsize24-14px"
          >
            Sharing your story helps understand yourself — feelings, passions,
            hopes. It lightens the load and offers relief from loneliness,
            anxiety, anger or guilt. Our experiences and hopes can benefit
            others – to know that the challenges are the same, learn new ways to
            cope and care… they aren’t alone but part of a team.
          </p>
        </div>
        <div class="md:pt-10 lg:pt-10 pt-0">
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-8"
            v-if="selectedFilter != null"
          >
            <PodcastCard
              v-for="item in tableData.data"
              :key="item._id"
              :item="item"
              :data="displayedPages"
              :selectedFilter="selectedFilter"
              @item-selected="updateSelectedList"
            />
          </div>
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-8"
            v-else
          >
            <PodcastCard
              v-for="item in categorywisepages.data"
              :key="item._id"
              :item="item"
              :category="item.pageCategory.name"
              :data="displayedPages"
              :selectedFilter="selectedFilter"
              @item-selected="updateSelectedList"
            />
          </div>
        </div>
        <p class="joinus-subtitle md-fsize18 md:pt-6 lg:pt-6 pt-4 fsize24-14px">
          Spread the love and share your caregiver stories
          <a class="text-primary cursor-pointer underline" :href="formRoute"
            >here.
          </a>
        </p>

        <div class="flex mt-4 flex-wrap">
          <b-pagination
            @change="handlePageChange"
            v-model="currentPage"
            :total-rows="rows"
            size="lg"
          ></b-pagination>
          <!-- <b-pagination
            @change="
              (value) => {
                currentPage = value;
              }
            "
            pills
            :total-rows="total_row"
            :per-page="perPage"
            size="lg"
            class="ml-auto flex flex-wrap"
          ></b-pagination> -->
        </div>
        <div class="border my-6 rounded-lg p-3 lg:mb-12 md:mb-12">
          <h3 class="fsize22 font-semibold">Disclaimer:</h3>
          <p class="leading-tight fsize16 mt-3 clr-2e2e2e">
            The information provided on this website is for educational purposes
            only and is not intended to be a substitute for professional medical
            advice, diagnosis, or treatment.
          </p>
          <p class="fsize16 mt-2 clr-2e2e2e">
            Readers should seek professional medical advice and treatment for
            any specific health-related issues."
          </p>
          <p class="fsize16 mt-2 clr-2e2e2e">
            The information presented on this website is provided 'as is'
            without any representations or warranties, express or implied. The
            website owner and contributors disclaim all liability for any
            damages or losses arising from the use of this information.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PodcastCard from "./PodcastCard.vue";
import BlogItem from "../../blogs/components/BlogItem.vue";
import pageMixin from "@/views/social/admin/pages/blog/mixins/pageMixin";
import _ from "lodash";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  mixins: [pageMixin],
  components: {
    BlogItem,
    PodcastCard,
    Multiselect,
  },
  props: {
    selected: {
      type: String,
    },
  },
  data() {
    return {
      items: [],
      filter1: [],
      filter2: [],
      filter3: [],
      filteredData: [],
      payload: {},
      categoryId: null,
      selectedTopic: null,
      selectedUsers: null,
      selectedCategories: null,
      hasFiltered: [],
      currentPage: 1,
      perPage: 16,
      rows: 0,
      tagid: [],
      oldTagTopic: "",
      oldTagCategories: "",
      oldTagUser: [],

      selectedFilter: null,
      selectedFilterOptions: ["Corporate"],
      tableData: [],

      formRoute: `${process.env.VUE_APP_WEB_URL}/request-form/share-your-story`,
    };
  },
  watch: {
    async selectedTopic(val) {
      this.tagid = this.tagid.filter((tag) => tag !== this.oldTagTopic);
      this.oldTagTopic = val;
      // console.log(val);
      if (val !== null) {
        this.tagid.unshift(val);
      }
      if (val || val === null) {
        let payload = {
          offset:
            this.currentPage >= 1
              ? (this.currentPage - 1) * this.offset
              : this.currentPage,
          id: this.categoryId,
          // isNotLoggedIn: this.isNotLoggedIn(),
          updatedAt: true,
          tagid: this.tagid,
        };

        let filteredAPIData = await this.$store.dispatch(
          "cms/getpagebycategory",
          payload
        );
        this.filteredData = filteredAPIData.data;
        // console.log(this.filteredData);
        this.loadData();
      }
    },
    async selectedCategories(val) {
      // console.log(val);
      this.tagid = this.tagid.filter((tag) => tag !== this.oldTagCategories);
      this.oldTagCategories = val;
      if (val !== null) {
        this.tagid.unshift(val);
      }
      if (val || val === null) {
        let payload = {
          offset:
            this.currentPage >= 1
              ? (this.currentPage - 1) * this.offset
              : this.currentPage,
          id: this.categoryId,
          // isNotLoggedIn: this.isNotLoggedIn(),
          updatedAt: true,
          tagid: this.tagid,
        };

        // console.log(payload);
        let filteredAPIData = await this.$store.dispatch(
          "cms/getpagebycategory",
          payload
        );
        this.filteredData = filteredAPIData.data.data;
        // console.log(this.filteredData);

        this.loadData();
      }
    },
    async selectedUsers(val) {
      let tagIdData = val.map((tag) => tag._id);
      // console.log(tagIdData, "***********");

      // this.tagid = this.tagid.filter((tag) => tag !== this.oldTagUser);
      this.tagid = this.tagid.filter((tag) => !this.oldTagUser.includes(tag));
      this.oldTagUser = tagIdData;
      if (tagIdData !== null) {
        // this.tagid.unshift(tagIdData);
        this.tagid = [...this.tagid, ...tagIdData];
      }
      // console.log(this.tagid);
      if (val || val === null) {
        let payload = {
          offset:
            this.currentPage >= 1
              ? (this.currentPage - 1) * this.offset
              : this.currentPage,
          id: this.categoryId,
          tagid: this.tagid,
        };

        let filteredAPIData = await this.$store.dispatch(
          "cms/getpagebycategory",
          payload
        );
        this.filteredData = filteredAPIData.data.data;
        // console.log(this.filteredData);
        this.loadData();
      }
    },

    categorywisepages(val) {
      if (this.tagid.length > 0) {
        this.categorywisepages = { ...this.categorywisepages };
      }
    },
    selectedFilter(value) {
      if (value != null) {
        this.getFFCPodcast();
      }
    },
    selected(value) {
      if (value != null && value == "Corporate") {
        this.selectedFilter = this.selected;
      }
    },
  },
  computed: {
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),

    // displayedPages() {
    //   return this.pages.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
    total_row() {
      return this.pages.length;
    },
  },
  methods: {
    async handlePageChange(value) {
      this.currentPage = value;
      let payload = {
        offset:
          this.currentPage > 1 ? (this.currentPage - 1) * 10 : this.currentPage,
        id: this.categoryId,
        // tagid: this.tagid,
      };
      this.filteredData = await this.$store.dispatch(
        "cms/getpagebycategory",
        payload
      );
      let el = document.getElementById("productToDisplay");
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
    handleClear() {
      this.selectedTopic = null;
      this.selectedUsers = null;
      this.selectedCategories = null;
      this.selectedFilter = null;
      this.loadData();
      this.init();
    },
    async loadData() {
      let loader = this.$loading();
      try {
        let categoryUsers = [],
          categoryTopics = [],
          category = [];
        if (this.selectedUsers != null)
          categoryUsers = this.categorywisepages.filter((x) => {
            return x.tags.includes(this.selectedUsers);
          });
        if (this.selectedCategories != null)
          category = this.categorywisepages.filter((x) => {
            return x.tags.includes(this.selectedCategories);
          });
        if (this.selectedTopic != null)
          categoryTopics = this.categorywisepages.filter((x) => {
            return x.tags.includes(this.selectedTopic);
          });

        let combinedFilter = [...categoryUsers, ...category, ...categoryTopics];
        this.filteredData = _.uniq(combinedFilter);

        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async init() {
      await this.$store.dispatch("cms/getPageCategories");

      this.pageCategories.forEach((element) => {
        if (element.route.includes("podcasts")) this.categoryId = element._id;
      });
      await this.$store.dispatch("cms/getTagsbyCategory", {
        categoryPage: this.categoryId,
      });
      await this.$store.dispatch("cms/getfilterbycategory", {
        categoryPage: this.categoryId,
      });
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      let filteredAPIData = await this.$store.dispatch(
        "cms/getpagebycategory",
        {
          id: this.categoryId,
        }
      );
      this.filteredData = filteredAPIData.data;
      this.rows = Number(this.filteredData.totalPages);
    },
    async getFFCPodcast() {
      let offset = 0;
      let payload = {
        pagination: true,
        limit: 9,
      };

      if (this.currentPage == 1) {
        Object.assign(payload, { offset: offset });
      } else {
        offset = 10 * this.currentPage - 10;
        Object.assign(payload, { offset: offset });
      }

      let result = await this.$store.dispatch("ffc/getPodcast", payload);
      console.log(result, "RESULT");
      this.tableData = result.data;
    },
    isNotLoggedIn() {
      if (sessionStorage.getItem("token")) {
        return false;
      } else {
        return true;
      }
    },
    updateSelectedList(item) {
      this.$store.commit("cms/SET_SELECTED_LIST", item);
    },
  },
  async mounted() {
    if (Object.keys(this.user).length !== 0) {
      let getUserPayload = {
        userId: this.user._id,
      };
      const getUser = await this.$store.dispatch(
        "auth/getUserByUserId",
        getUserPayload
      );
    }
    //this.loadData();
    this.init();
  },
};
</script>
<style>
.lricon .multiselect__select {
  right: 12px !important;
  top: 5px !important;
}
.inp-search {
  border-radius: 50px !important;
  border: 1px solid #4f0a4b !important;
  height: 47px !important;
}

.bg-insight-cs .multiselect__tags {
  border: 1px solid #4f0a4b;
  border-radius: 25px;
  height: auto;
  width: 275px;
}

.bg-insight-cs .multiselect__tag {
  background: #4f0a4b;
  color: #fff;
  margin-bottom: 1px;
}
.bg-insight-cs .multiselect__option--highlight {
  background: #4f0a4b !important;
  color: #fff;
}
.bg-insight-cs
  .multiselect__option--selected.multiselect__option--highlight:after {
  background: #4f0a4b !important;
  color: #fff;
}
.bg-insight-cs .multiselect__option--highlight:after {
  display: none;
}
.bg-insight-cs .multiselect__option--selected.multiselect__option--highlight {
  background: #4f0a4b;
  color: #fff;
}

@media (max-width: 641px) {
  .inp-search {
    height: 40px !important;
  }
  .bg-insight-cs .multiselect__tags {
    border: 1px solid #4f0a4b;
    border-radius: 25px;
    height: auto;
    width: auto;
  }
  .lricon .multiselect__select {
    right: 1px !important;
    top: 1px !important;
  }
}
</style>
